import styled from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';

import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import { theme } from '../../assets/styles';

const Theme = theme as { [key: string]: any };

export const InputWrapper = styled.div`
  position: relative;
  .error-autoComplete{
    bottom: -22px;
  }
`;

export const Label = styled.div<{component: string, disabled: any}>``

export const SAutocomplete = styled(Autocomplete)<{ onChange: any, onClose: any }>`
  & .MuiInputBase-root .MuiInputBase-input {
    padding: 2px 4px;
  }
  & .MuiFormLabel-root {
    height: 100%;
    padding-top: 9px;
  }
  & .MuiAutocomplete-inputRoot {
    border-radius: 8px;
  }
  fieldset{
    border-color: ${Theme.darkYellow} !important;
  }
`;

export const SCheckbox = styled(Checkbox)<{ checked: boolean }>`
    padding: 4px;
    margin-right: 8px;
    color: ${({checked}) => checked ? Theme.darkYellow : 'unset'} !important;
`;

export const SRadio = styled(Radio)<{ checked: boolean }>`
    padding: 4px;
    margin-right: 8px;
    color: ${({checked}) => checked ? Theme.darkYellow : 'unset'} !important;
`;

export const RenderOptionLi = styled.li<{ checked:boolean }>`
  display: flex !important;
  justify-content: space-between !important;
  background-color: ${({checked}) => checked ? Theme.lightSecond : 'unset'} !important;
  border-bottom: 1px solid ${Theme.borderColor};
  :last-child{
    border-bottom: unset;
  }
  :hover{
    background-color: ${Theme.lightSecond} !important;
  }
  span{
    display: inline-block;
  }
`

export const SChipWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
`;
